import styled from 'styled-components';
import color from '../../../../config/colors.json';

export const StyledH3 = styled.h3`
    font-family: 'Poppins', Arial, Helvetica, sans-serif;
    font-size: 14px;
    letter-spacing: 0px;
    color: ${color.dark};
    opacity: 1;
    margin: 30px 0;
`;
